import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import translationTR from "./Locales/tr.json";
import translationENG from "./Locales/en.json";

// Context'leri build'e dahil et
const tenantTrContext = require.context("./Locales/tenant", true, /tr\.json$/);
const tenantEnContext = require.context("./Locales/tenant", true, /en\.json$/);

export const initI18n = async () => {
  let tenantConfig = { tenantId: "default" };

  try {
    // Nginx'in sunduğu config.json'ı çek
    const response = await fetch('/config.json');
    tenantConfig = await response.json();
    localStorage.setItem("TENANT_ID", tenantConfig.tenantId);
  } catch (e) {
    console.error("Config yüklenemedi, default kullanılıyor", e);
  }

  const tid = tenantConfig.tenantId;
  
  // Tenant dosyalarını çek
  const trPath = `./${tid}/tr.json`;
  const enPath = `./${tid}/en.json`;

  const tenantTr = tenantTrContext.keys().includes(trPath) ? tenantTrContext(trPath) : {};
  const tenantEn = tenantEnContext.keys().includes(enPath) ? tenantEnContext(enPath) : {};

  return i18n
    .use(initReactI18next)
    .init({
      resources: {
        tr: { translation: { ...translationTR, ...(tenantTr.default || tenantTr) } },
        en: { translation: { ...translationENG, ...(tenantEn.default || tenantEn) } },
      },
      lng: localStorage.getItem("I18N_LANGUAGE") || "tr",
      fallbackLng: "tr",
      interpolation: { 
        escapeValue: false,
        // {{brandName}} gibi değişkenleri config'den gelen verilerle otomatik doldurur
        defaultVariables: tenantConfig 
      },
    });
};

export default i18n;